import firebase from 'firebase'
import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/pages/Index'
import Profile from '@/components/pages/Profile'
import ProfileMain from '@/components/pages/ProfileMain'
import ProfileGoals from '@/components/pages/ProfileGoals'
import ProfileFriends from '@/components/pages/ProfileFriends'
import Settings from '@/components/pages/Settings'
import Login from '@/components/auth/Login'
import Join from '@/components/auth/Join'
import ForgotPassword from '@/components/auth/ForgotPassword'
import NewGoal from '@/components/goals/NewGoal'
import SingleGoal from '@/components/goals/SingleGoal'
import EditGoal from '@/components/goals/EditGoal'
import Error404 from '@/components/pages/Error404'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  linkExactActiveClass: 'is-active',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/join',
      name: 'Join',
      component: Join
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/forgotpassword',
      name: 'ForgotPassword',
      component: ForgotPassword
    },
    {
      path: '/404',
      name: 'Error404',
      component: Error404
    },
    {
      path: '/:username',
      name: 'Profile',
      component: Profile,
      meta: {
        requiresAuth: true
      },
      children: [
        { path: '', component: ProfileMain, name: 'Profile' },
        { path: 'goals', component: ProfileGoals, name: 'ProfileGoals' },
        { path: 'friends', component: ProfileFriends, name: 'ProfileFriends' },
      ]
    },
    {
      path: '/goals/new',
      name: 'NewGoal',
      component: NewGoal,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/goals/:id/edit',
      name: 'EditGoal',
      component: EditGoal,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/goals/:id',
      name: 'SingleGoal',
      component: SingleGoal
    }
  ]
})

router.beforeEach((to, from, next) => {
  if(to.matched.some(rec => rec.meta.requiresAuth)) {
    // check auth state of user
    let user = firebase.auth().currentUser
    if(user) {
      // user signed in, proceed to route
      next()
    } else {
      // no user signed in, redirect to login
      next({ name: 'Login'})
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js